import { createApiActions } from '../../../helpers/actions';

export const getUtilitiesList = createApiActions()(
  'company/getUtilitiesList',
  'company/getUtilitiesListSuccess',
  'company/getUtilitiesListError',
  () => {}
);
